import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import SelectedOfferTextArea from '../SelectedOfferTextArea';

interface Props {
  placeholder: string;
  value: string;
  error?: string;
  isMobile?: boolean;
  onChange: (arg0: string) => void;
  onBlur: () => void;
}

const SingleSelectedOffersRequirements: React.FC<
  React.PropsWithChildren<Props>
> = ({ placeholder, value, error, isMobile, onChange, onBlur }) => {
  const { t } = useTranslation();

  return (
    <RequirementsBox>
      {!isMobile && <Title>{t('Information Requirements')}</Title>}
      <SelectedOfferTextArea
        error={error}
        name="textarea"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
    </RequirementsBox>
  );
};

const Title = styled.h3`
  font-weight: 700;
  font-size: 1.8rem;
  margin-bottom: 1.6rem;
`;

const RequirementsBox = styled.div`
  padding: 1.6rem;
  background-color: #f7f8fb;
  border-radius: 6px;
`;

export default SingleSelectedOffersRequirements;
